import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import Select from 'react-select';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'font-awesome/css/font-awesome.min.css';
import '../../wallet.css';
import BarcodeScanner from './BarcodeScanner';
import ReportIssueButton from './ReportIssueButton';

export default function InScan() {
  // State to hold the status counts
  const [shipmentDetails, setShipmentDetails] = useState(null);

  // Optional finance Project to link the scanned AWBs to.
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const res = await axios.get(`${API_URL}shypvdriverapp/projects?active=true`);
        setProjects(res.data?.data || []);
      } catch (err) {
        // Project linking is optional; scanning works without it.
        console.warn('Could not load projects:', err.message);
      }
    };
    fetchProjects();
  }, []);

  const projectOptions = projects.map((p) => ({
    value: p.id,
    label: `${p.projectCode} — ${p.projectName}${p.partnerName ? ` (${p.partnerName})` : ''}`,
  }));

  const handleScanSuccess = (details) => {
    setShipmentDetails(details); // Set the scanned shipment details
  };

  return (
    <div className="wallet-page">
      <ReportIssueButton pageContext="INSCAN" pageLabel="InScan" awb={shipmentDetails?.awb} />
      <div className="w-topbar">
        <div className="w-topbar-left">
          <div className="w-icon-badge"><i className="fa fa-barcode" aria-hidden="true" /></div>
          <div>
            <h2 className="w-title">In Scan</h2>
            <p className="w-subtitle">Scan AWBs into a homebase, optionally linked to a finance project.</p>
          </div>
        </div>
      </div>

      {/* Optional: assign these in-scans to a finance Project */}
      <div className="w-card">
        <div className="w-card-header">
          <span className="w-card-title"><i className="fa fa-folder-open" aria-hidden="true" /> Project (optional)</span>
        </div>
        <div className="w-card-body">
          <Select
            options={projectOptions}
            value={selectedProject}
            onChange={setSelectedProject}
            placeholder="No project — don’t link"
            isClearable
            isSearchable
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
          {selectedProject && (
            <div style={{ fontSize: 12, color: '#00a6ed', marginTop: 8 }}>
              Scanned AWBs will be linked to <strong>{selectedProject.label}</strong>.
            </div>
          )}
        </div>
      </div>

      <BarcodeScanner onScanSuccess={handleScanSuccess} projectId={selectedProject ? selectedProject.value : null} />
    </div>
  );
}
